import React, { useState, useEffect } from "react";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import InputUI from "@/componentsUI/Input";
import styles from "./index.module.less";

interface BankAccountInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const BankAccountInput: React.FC<BankAccountInputProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const { t } = useTranslationPlus("Wallet");
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleChange = (val: string) => {
    const numericValue = val.replace(/\D/g, "");
    setInputValue(numericValue);
    onChange?.(numericValue);
  };

  const formatAccountNumber = (num: string) => {
    return num.replace(/\d{4}(?=\d)/g, "$& ");
  };

  return (
    <div className={styles.bankAccountInput}>
      <InputUI
        value={formatAccountNumber(inputValue)}
        onChange={handleChange}
        placeholder={
          placeholder || t("Please enter the correct account number")
        }
        disabled={disabled}
        className={styles.accountInput}
        maxLength={25}
      />
      <div className={styles.hint}>
        {t("Please enter your bank account number digits only")}
      </div>
    </div>
  );
};

export default BankAccountInput;
